<template>
  <div>
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <v-card v-else>
      <v-card-title>
        {{ venta.comprobante.tipo }} {{ venta.comprobante.numero }}
        <v-spacer></v-spacer>
        <v-btn
          class="ma-2"
          color="green"
          fab
          small
          dark
          @click="_dialogFacturarVenta()"
          v-if="venta.comprobante.tipo == 'PRESUPUESTO'"
          :loading="loadingFacturarVenta"
        >
          <v-icon>mdi-cart-check</v-icon>
        </v-btn>
        <v-btn
          class="ma-2"
          color="orange"
          v-if="venta.comprobante.pdf"
          fab
          small
          dark
          @click="_pdf()"
          :loading="loadingPdf"
        >
          <v-icon>mdi-file</v-icon>
        </v-btn>
        <v-btn class="ma-2" color="red" fab small dark @click="_cerrar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Vendedor</th>
                <th class="text-left">Fecha y Hora</th>
                <th class="text-left" v-if="venta.pedido">Orden #</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ venta.usuario.nombre }}</td>
                <td>
                  {{ venta.fechaAlta | moment("dddd D [de] MMMM YYYY HH:mm") }}
                </td>
                <td v-if="venta.pedido">
                  {{ venta.pedido.slice(-5) }}
                  <v-icon @click="$router.push(`/pedido/${venta.pedido}`)"
                    >mdi-eye</v-icon
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Cliente</th>
                <th class="text-left">Documento</th>
                <th class="text-left">Tipo Responsable</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ venta.cliente.nombre }}</td>
                <td>
                  {{ venta.cliente.documento.tipo.descripcion }}
                  {{ venta.cliente.documento.numero }}
                </td>
                <td>{{ venta.cliente.tipo_responsable.descripcion }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Direccion de Facturacion</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ venta.direccion }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Producto</th>
                <th class="text-left">Precio Unitario</th>
                <th class="text-left">Cantidad</th>
                <th class="text-left">Precio Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in venta.productos" :key="index">
                <td>({{ item.producto.codigo }}) {{ item.producto.nombre }}</td>
                <td>$ {{ item.precio_unitario }}</td>
                <td>{{ item.cantidad }}</td>
                <td>$ {{ item.precio_total }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Subtotal</th>
                <th class="text-left">Descuentos</th>
                <th class="text-left">Recargos</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>$ {{ venta.subtotal }}</td>
                <td>$ {{ venta.descuento }}</td>
                <td>$ {{ venta.recargo }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Recibimos</th>
                <th class="text-left">Recargo</th>
                <th class="text-left">Monto</th>
                <th class="text-left">Vuelto</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in venta.medios_pago" :key="index">
                <td>{{ item.medio }} {{ item.comprobante }}</td>
                <td>$ {{ item.recargo }}</td>
                <td>$ {{ item.monto }}</td>
                <td>$ {{ item.vuelto }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <b>$ {{ venta.total }}</b>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogFacturarVenta" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Facturar Venta
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            label="Seleccione cliente"
            :items="listadoClientes"
            :loading="loadingClientes"
            v-model="clienteFactura"
            item-text="nombre"
            return-object
          ></v-autocomplete>
          <v-select
            label="Seleccione direccion"
            :items="direccionesFactura"
            v-if="direccionesFactura"
            v-model="direccionFactura"
          ></v-select>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="!verificarFacturarVenta"
            @click="facturarVenta"
            :loading="loadingFacturarVenta"
          >
            Generar Factura
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Ventas_Ver",
  data() {
    return {
      venta: {
        comprobante: {
          tipo: "",
        },
        cliente: {
          nombre: "",
          documento: {
            tipo: {
              codigo: "",
              descripcion: "",
            },
            numero: "",
          },
          tipo_responsable: {
            codigo: "",
            descripcion: "",
          },
        },
        fechaAlta: "",
        pedido: null,
      },
      listadoClientes: [],
      clienteFactura: null,
      direccionFactura: null,
      loading: true,
      loadingPdf: false,
      loadingImprimirPresupuesto: false,
      loadingFacturarVenta: false,
      dialogFacturarVenta: false,
      loadingClientes: false,
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    direccionesFactura() {
      return this.clienteFactura
        ? this.clienteFactura.direcciones.map(
            (v) =>
              `${v.direccion_1}, ${v.ciudad.nombre}, ${v.provincia.nombre} CP ${v.cp}`
          )
        : null;
    },
    verificarFacturarVenta() {
      if(!this.clienteFactura || !this.direccionFactura) return false
      return true
    }
  },
  created() {
    this._obtenerVenta();
  },
  methods: {
    async _obtenerVenta() {
      this.loading = true;
      try {
        const venta = await axios.get(`/venta/${this.id}`);
        this.venta = venta.data;
        if (this.venta.comprobante.tipo == "FACTURA")
          this.venta.comprobante.tipo += ` ${this.venta.comprobante.codigo}`;
        this.loading = false;
      } catch (error) {
        this.$router.push(`/ventas`);
      }
      this.loading = false;
    },
    async _obtenerClientes() {
      this.loadingClientes = true;
      try {
        const clientes = await axios.get("/personas/cliente");
        this.listadoClientes = clientes.data;
      } catch (error) {
        console.log(error);
      }
      this.loadingClientes = false;
    },
    _dialogFacturarVenta() {
      this.dialogFacturarVenta = true;
      this.clienteFactura = null;
      this.direccionFactura = null;
      this._obtenerClientes();
    },
    async facturarVenta() {
      this.loadingFacturarVenta = true;
      try {
        let productos = this.venta.productos.map((producto) => ({
          ...producto,
          nombre: producto.producto.nombre,
          iva: producto.producto.iva,
          codigo: producto.producto.codigo,
          producto: undefined,
        }));
        let venta = {
          ...this.venta,
          _id: this.id,
          productos,
          comprobante: {
            tipo: "FACTURA",
          },
          cliente: this.clienteFactura,
          direccion: this.direccionFactura,
          generarFacturaPresupuesto: true,
        };
        await axios.post("/ventas/fe", venta);
        this._obtenerVenta();
        this.dialogFacturarVenta = false
      } catch (error) {
        console.log(error);
      }
      this.loadingFacturarVenta = false;
    },
    _pdf() {
      window.open(this.venta.comprobante.pdf);
    },
    _cerrar() {
      if (this.$route.params.nuevaVenta) {
        this.$router.push(`/ventas/nuevo`);
      } else {
        this.$router.go(-1)
      }
    },
  },
};
</script>
